import React, { useEffect, useRef } from "react";
import { TypewriterSubtitle } from "./TypewriterSubtitle";
import * as THREE from "three";

export function HeroSection () {

    const heroCanvasRef = useRef(null);

    // Hero 3D scene (AI core + orbiting nodes)
    useEffect(() => {
        const canvas = heroCanvasRef.current;
        if (!canvas) return;
    
        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(
        50,
        window.innerWidth / window.innerHeight,
        0.1,
        100
        );
        camera.position.set(0, 0, 9);
        const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
        renderer.setSize(window.innerWidth, window.innerHeight);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    
        const core = new THREE.Mesh(
        new THREE.IcosahedronGeometry(1.6, 1),
        new THREE.MeshBasicMaterial({ color: 0x1da1f2, wireframe: true, transparent: true, opacity: 0.55 })
        );
        scene.add(core);
    
        const innerCore = new THREE.Mesh(
        new THREE.IcosahedronGeometry(1.1, 0),
        new THREE.MeshBasicMaterial({ color: 0x49d6ff, wireframe: true, transparent: true, opacity: 0.35 })
        );
        scene.add(innerCore);
    
        const ringGroup = new THREE.Group();
        [2.6, 3.4, 4.2].forEach((r, i) => {
        const ring = new THREE.Mesh(
            new THREE.TorusGeometry(r, 0.004, 8, 120),
            new THREE.MeshBasicMaterial({ color: 0x49d6ff, transparent: true, opacity: 0.18 })
        );
        ring.rotation.x = Math.PI / 2 + i * 0.4;
        ring.rotation.y = i * 0.6;
        ringGroup.add(ring);
        });
        scene.add(ringGroup);
    
        const particleCount = 260;
        const positions = new Float32Array(particleCount * 3);
        for (let i = 0; i < particleCount; i++) {
        const r = 5 + Math.random() * 4;
        const theta = Math.random() * Math.PI * 2;
        const phi = Math.acos(Math.random() * 2 - 1);
        positions[i * 3] = r * Math.sin(phi) * Math.cos(theta);
        positions[i * 3 + 1] = r * Math.sin(phi) * Math.sin(theta);
        positions[i * 3 + 2] = r * Math.cos(phi);
        }
        const pGeo = new THREE.BufferGeometry();
        pGeo.setAttribute("position", new THREE.BufferAttribute(positions, 3));
        const pMat = new THREE.PointsMaterial({ color: 0x49d6ff, size: 0.045, transparent: true, opacity: 0.7 });
        const particles = new THREE.Points(pGeo, pMat);
        scene.add(particles);
    
        let mouseX = 0;
        let mouseY = 0;
        const onMouseMove = (e) => {
        mouseX = e.clientX / window.innerWidth - 0.5;
        mouseY = e.clientY / window.innerHeight - 0.5;
        };
        window.addEventListener("mousemove", onMouseMove);
    
        let frameId;
        const animate = () => {
        frameId = requestAnimationFrame(animate);
        core.rotation.y += 0.0022;
        core.rotation.x += 0.0009;
        innerCore.rotation.y -= 0.0032;
        ringGroup.rotation.y += 0.0014;
        particles.rotation.y += 0.0006;
        camera.position.x += (mouseX * 1.4 - camera.position.x) * 0.03;
        camera.position.y += (-mouseY * 1.0 - camera.position.y) * 0.03;
        camera.lookAt(0, 0, 0);
        renderer.render(scene, camera);
        };
        animate();
    
        const onResize = () => {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, window.innerHeight);
        };
        window.addEventListener("resize", onResize);
    
        return () => {
        cancelAnimationFrame(frameId);
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("resize", onResize);
        pGeo.dispose();
        pMat.dispose();
        renderer.dispose();
        };
    }, []);
    
    return (
        <section className="hero">
            <canvas id="hero-canvas" ref={heroCanvasRef}></canvas>
            <div className="container hero-inner">
            <div className="eyebrow">AI AUTOMATION · ERP · CLOUD</div>
            <h1>
                Systems that think,
                <br />
                <span>so your business can move.</span>
            </h1>

            <TypewriterSubtitle className="sub" />

            <div className="hero-ctas">
                <a className="btn btn-primary magnetic" href="/contact">Book a Demo</a>
                <a className="btn btn-ghost magnetic" href="#services">Explore Services</a>
            </div>
            </div>
            <div className="scroll-indicator">
            <span>SCROLL</span>
            <div className="scroll-line"></div>
            </div>
        </section>
    )
}